/**
 * QR code styles: the *shape* of the modules, not their color. Colors always
 * come from the profile's Ditto theme (see `qrColors` in profileTheme.ts).
 *
 * Every style keeps the three finder patterns solid and preserves the quiet
 * zone, so all of them stay scannable.
 */
export type QrStyle =
  | 'square'
  | 'rounded'
  | 'dots'
  | 'lines'
  | 'columns'
  | 'diamond';

export interface QrStyleOption {
  id: QrStyle;
  label: string;
}

export const QR_STYLES: QrStyleOption[] = [
  { id: 'rounded', label: 'Rounded' },
  { id: 'square', label: 'Classic' },
  { id: 'dots', label: 'Dots' },
  { id: 'lines', label: 'Lines' },
  { id: 'columns', label: 'Columns' },
  { id: 'diamond', label: 'Diamond' },
];

export const DEFAULT_QR_STYLE: QrStyle = 'rounded';
